import { useAnimation } from 'framer-motion';
import { useAtom } from 'jotai';
import { useEffect } from 'react';

import { isAnimationPlayedAtom } from '../store/index.atom';

const useCtaButtonAnimation = () => {
  const buttonAnimationControls = useAnimation();
  const textWrapperAnimationControls = useAnimation();
  const textAnimationControls = useAnimation();

  const [isAnimationPlayed, setIsAnimationPlayed] = useAtom(
    isAnimationPlayedAtom,
  );

  useEffect(() => {
    if (!isAnimationPlayed) {
      textWrapperAnimationControls.set({
        width: 50,
        height: 50,
      });

      buttonAnimationControls.set({
        y: 100,
        opacity: 0,
      });

      textAnimationControls.set({
        opacity: 0,
      });

      buttonAnimationControls
        .start({
          y: 0,
          opacity: 1,
        })
        .then(() => {
          textWrapperAnimationControls
            .start({
              width: 'fit-content',
              height: 50,
            })
            .then(() => {
              textAnimationControls.start({
                opacity: 1,
              });
              setIsAnimationPlayed(true);
            });
        });
    }
  }, [isAnimationPlayed]);

  return {
    buttonAnimationControls,
    textWrapperAnimationControls,
    textAnimationControls,
  };
};

export default useCtaButtonAnimation;
